import { render, staticRenderFns } from "./customer-service-order-passed.vue?vue&type=template&id=1b5e672c"
import script from "./customer-service-order-passed.vue?vue&type=script&lang=js"
export * from "./customer-service-order-passed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports